import { EMPTY_STRING } from '../../../../../constants/common'
import { LISTING_VIEWING_ROW_ACTIONS } from '../../../../RentalPortalViewing'

import { LISTING_VIEWINGS_STATE } from './RentalPortalListingProfileViewings.constants'

export function getListingViewingsState({ hasError, isInitiated, viewings }) {
  if (hasError) {
    return LISTING_VIEWINGS_STATE.error
  }

  if (!isInitiated) {
    return LISTING_VIEWINGS_STATE.loading
  }

  return viewings?.length > 0
    ? LISTING_VIEWINGS_STATE.table
    : LISTING_VIEWINGS_STATE.empty
}

export function getListingViewingApplicantLabel(viewing) {
  return viewing?.applicant?.label ?? EMPTY_STRING
}

export function getListingViewingItemActions() {
  return LISTING_VIEWING_ROW_ACTIONS
}

export function getIsListingViewingsEmpty(state) {
  return state === LISTING_VIEWINGS_STATE.empty
}

export function getIsListingViewingsError(state) {
  return state === LISTING_VIEWINGS_STATE.error
}
